import { rem } from 'polished'

export const TRIP_LIST_GRID_COLUMNS = `${rem(40)} minmax(${rem(108)}, ${rem(128)}) minmax(${rem(120)}, ${rem(160)}) minmax(${rem(260)}, 1fr) minmax(${rem(168)}, ${rem(220)}) minmax(${rem(104)}, ${rem(128)}) minmax(${rem(128)}, ${rem(160)}) ${rem(104)}`
